import { create } from 'zustand';

export type ToolMode = 'pen' | 'eraser';

interface ToolState {
  mode: ToolMode;
  color: string;
  sizeIdx: number;
  setMode: (m: ToolMode) => void;
  setColor: (c: string) => void;
  setSize: (s: number) => void;
}

export const useTool = create<ToolState>((set) => ({
  mode: 'pen',
  color: '#ffffff',
  sizeIdx: 5,
  setMode: (mode) => set({ mode }),
  setColor: (color) => set({ color }),
  setSize: (sizeIdx) => set({ sizeIdx }),
}));
